import React from 'react';

const EnrollmentRefundPolicy: React.FC = () => (
  <div className="min-h-screen bg-slate-50 text-slate-900">
    <div className="max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-semibold text-slate-900">Enrollment & Refund Policy</h1>
      <p className="mt-2 text-sm text-slate-600">Last updated: Jan 18, 2026</p>

      <section className="mt-8 space-y-4 text-sm text-slate-700">
        <p>
          This policy outlines payment terms for program application fees, deposits, and tuition.
          Please review carefully before submitting a payment.
        </p>

        <div>
          <h2 className="text-base font-semibold text-slate-900">Application Fee</h2>
          <p className="mt-2">
            The application fee is non-refundable. It covers processing and review of your application.
          </p>
        </div>

        <div>
          <h2 className="text-base font-semibold text-slate-900">Program Deposit</h2>
          <p className="mt-2">
            Deposits reserve your seat in the program. Refund eligibility depends on the program timeline
            and is communicated in your acceptance packet.
          </p>
        </div>

        <div>
          <h2 className="text-base font-semibold text-slate-900">Tuition & Remaining Balance</h2>
          <p className="mt-2">
            Tuition balances may be paid in full or through an approved installment plan. Late or missed
            payments can result in loss of enrollment.
          </p>
        </div>

        <div>
          <h2 className="text-base font-semibold text-slate-900">Contact</h2>
          <p className="mt-2">
            If you have questions about this policy, contact support@muslimstudyabroad.com.
          </p>
        </div>
      </section>
    </div>
  </div>
);

export default EnrollmentRefundPolicy;
